import Header from "./header";
import NavbarPublic from "./navbarPublic";
//import Footer from './footer'

/*type NavLayoutProps = {
    children: React.ReactNode,
};*/

//import React from 'react'

//NOTA: usado en PrivateRoutes para menu solo de paginas privadas

export const LayoutPublic = ({ children }) => {
  return (
    <div className="h-dvh flex flex-col">
      <Header>
        <NavbarPublic />
      </Header>
      <main className="flex-1 min-h-0 overflow-auto">
        {children}
      </main>
    </div>
  )
}

